import store from "@/store/store";
import { ActionNames } from "@/store/actions";
import router from "@/router";

export async function loadJobDetail(jobId: string): Promise<boolean> {
  const jobIdNumber = parseInt(jobId, 10);
  if (store.state.Job.JobId !== jobIdNumber) {
    await store.dispatch(ActionNames.SetJobDetail, jobId);
    await store.dispatch(ActionNames.SetChecklistQA);
  }

  // if no contact on job then redirect, need to also handle this in loadexam and load parts
  if (store.state.Job.JobDetail && !store.state.Job.JobDetail.ContactId) {
    router.push("/ContactLoadFailed");
    return false;
  } else if (!store.state.Job.JobDetail) {
    throw new Error("Failed to load Job Detail");
  }
  return true;
}

export async function loadExamDetail(jobId: string): Promise<boolean> {
  if (!store.state.Job.JobDetail) {
    if (!(await loadJobDetail(jobId))) {
      return false;
    }
  }
  await store.dispatch(ActionNames.SetExamDetail, jobId);
  return true;
}

export async function loadParts(jobId: string): Promise<boolean> {
  if (!store.state.Job.JobDetail) {
    if (!(await loadJobDetail(jobId))) {
      await store.dispatch(ActionNames.SetExamDetail, jobId);
    }
  }

  if (!store.state.Job.ExamDetail) {
    if (!(await loadExamDetail(jobId))) {
      return false;
    }
  }
  await store.dispatch(ActionNames.SetPartsDetail, jobId);

  return true;
}
